import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ListTicketCategoryComponent } from 'modules/ticket-category/list-ticket-category/list-ticket-category.component';
import { CreateTicketCategoryComponent } from 'modules/ticket-category/create-ticket-category/create-ticket-category.component';
import { SharedModule } from 'modules/shared/shared.module';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
  declarations: [
    ListTicketCategoryComponent,
    CreateTicketCategoryComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatDialogModule,
    MatInputModule,
    MatMenuModule,
    FormsModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    RouterModule.forChild([
      {
        path: 'list',
        component: ListTicketCategoryComponent,
        canActivate: [],
      },
      {
        path: 'create',
        component: CreateTicketCategoryComponent,
        canActivate: [],
      },
    ]),
  ],
  exports: [
    ListTicketCategoryComponent,
    CreateTicketCategoryComponent,
  ],
})
export class TicketCategoryModule { }
